import {Header, Pagination} from '@/components';
import type {PaginationProps} from '@/components/common/Pagination';

import TransactionSearch from './TransactionSearch';
import TransactionTableContent from './TransactionTableContent';
import useTransactionList from './useTransactionList';

const TransactionList = () => {
  const {
    error,
    isLoading,
    isSearch,
    isPageReset,
    fetchTransactionList,
    pageInfo,
    transactionList,
    exportFilters,
    filterCount,
    currentFilters,
    filtersToApply,
    handleApplyFilters,
    clearFilters,
    selectCurrentFilters,
    selectAppliedFilters,
  } = useTransactionList();
  const countSuffix =
    pageInfo.total > 0 ? `(${pageInfo.total?.toLocaleString()})` : '';

  return (
    <main className="mt-10 mb-5 mx-4 md:mx-10">
      <Header
        title={`Transactions ${countSuffix}`}
        dataCy="admin-transactions-heading"
      />

      <TransactionSearch
        transactions={transactionList}
        exportFilters={exportFilters}
        filterCount={filterCount}
        currentFilters={currentFilters}
        filtersToApply={filtersToApply}
        clearFilters={clearFilters}
        selectCurrentFilters={selectCurrentFilters}
        selectAppliedFilters={selectAppliedFilters}
        handleApplyFilters={handleApplyFilters}
      />

      <section className="pt-5 md:pt-5">
        <TransactionTableContent
          error={error}
          isLoading={isLoading}
          items={transactionList}
          onRetry={() => fetchTransactionList({})}
        />
      </section>
      {transactionList && transactionList.length ? (
        <Pagination
          onPageChange={fetchTransactionList as PaginationProps['onPageChange']}
          total={pageInfo.total}
          isSearch={isSearch}
          isPageReset={isPageReset}
        />
      ) : null}
    </main>
  );
};

export default TransactionList;
